module.exports = __webpack_public_path__ + "img/IEC30415.c45a84d9.png";